<div class="modal-overlay" (click)="onClose()">
  <div class="modal-container large" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h2 class="modal-title">Membres - {{ data.name }}</h2>
      <button class="close-btn" (click)="onClose()">×</button>
    </div>

    <div class="modal-body members-grid">
      @if (errorMessage) {
        <div class="alert alert-error mb-4">{{ errorMessage }}</div>
      }

      <div>
        <h3>Membres</h3>
        <div class="list-card">
          @for (member of members; track member.id) {
            <div class="member-row">
              <span>{{ member.firstName }} {{ member.lastName }} ({{ member.username }})</span>
              <button class="btn btn-outline btn-sm" (click)="removeMember(member)">Retirer</button>
            </div>
          } @empty {
            <p class="empty-text">Aucun membre</p>
          }
        </div>
      </div>

      <div>
        <h3>Candidats</h3>
        <div class="list-card">
          @for (member of candidates; track member.id) {
            <div class="member-row">
              <span>{{ member.firstName }} {{ member.lastName }} ({{ member.username }})</span>
              <button class="btn btn-primary btn-sm" (click)="addMember(member)">Ajouter</button>
            </div>
          } @empty {
            <p class="empty-text">Aucun candidat</p>
          }
        </div>
      </div>
    </div>
  </div>
</div>
